"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getSpecification_1 = __importDefault(require("../getSpecification"));
/**
 * Возвращает объект значений (полей value) для массива имен спецификаций
 * @param {string} groupName имя группы
 * @param {string[]} specifications массив имен спецификаций
 */
function getSpecificationsForGroup(specification, groupName, specifications) {
    var values = specifications.reduce(function (acc, field) {
        var value = getSpecification_1.default(specification, groupName, field);
        if (value) {
            acc[field] = value;
        }
        return acc;
    }, {});
    return values;
}
exports.default = getSpecificationsForGroup;
